var ModAlert = {
    config: {
        type     : '',
        title    : '',
        text     : '',
        timeout  : 3000,
        autohide : true,
        showicon : true,
        showtitle: true
    },
    type: {
        success: 'Успешно',
        info   : 'Информация',
        warning: 'Внимание!',
        error  : 'Ошибка'
    },

    /* показать уведомление */
    addAlert: function(param) {
        var self = this;

        /* контейнер один на страницу */
        var box = document.querySelector('.modAlert');
        if (!box) {
            box = document.createElement('div');
            box.className = 'modAlert';
            document.body.appendChild(box);
        }

        /* мерж настроек */
        var opt = {};
        for (var k in this.config) opt[k] = this.config[k];
        for (var k in param)      opt[k] = param[k];

        /* заголовок по-умолчанию */
        if (!opt.title && this.type[opt.type]) opt.title = this.type[opt.type];

        /* css-классы элемента */
        var classes = ['modAlert-item'];
        if (opt.type) {
            classes.push('modAlert-' + opt.type);
        }
        if (!opt.showicon) {
            classes.push('modAlert-noicon');
        }
        if (!opt.title || !opt.text || !opt.showtitle) {
            classes.push('modAlert-onerow');
            if (!opt.showtitle) classes.push('modAlert-notitle');
        }

        /* DOM-элемент уведомления */
        var item = document.createElement('div');
        item.className = classes.join(' ');

        if (opt.showicon) {
            var ico = document.createElement('div');
            ico.className = 'modAlert-icon';
            item.appendChild(ico);
        }
        if (opt.title && opt.showtitle) {
            var ttl = document.createElement('div');
            ttl.className = 'modAlert-title';
            ttl.innerHTML = opt.title;
            item.appendChild(ttl);
        }
        if (opt.text) {
            var txt = document.createElement('div');
            txt.className = 'modAlert-text';
            txt.innerHTML = opt.text;
            item.appendChild(txt);
        }
        /* 1. кнопка-крестик */
        var closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'modAlert-close';
        closeBtn.setAttribute('aria-label', 'Закрыть');
        item.appendChild(closeBtn);

        /* 2. обработчик крестика */
        closeBtn.addEventListener('click', function (e) {
            e.stopPropagation();   // чтобы не сработал общий клик по блоку
            self.hideItem(item);
        });
        /* анимация появления */
        item.style.display = 'none';
        box.appendChild(item);
        slideDown(item, 200);

        /* закрыть по клику */
        item.addEventListener('click', function() {
            self.hideItem(item);
        });

        /* авто-скрытие */
        if (opt.autohide && opt.timeout > 0) {
            setTimeout(function() {
                self.hideItem(item);
            }, opt.timeout);
        }

        return false;
    },

    /* убрать элемент */
    hideItem: function(elem) {
        var box   = elem.parentNode;
        var width = box.offsetWidth;
        animate(elem, {left: -width}, 220, function() {
            elem.remove();
            if (box.querySelectorAll('.modAlert-item').length === 0) {
                box.remove();
            }
        });
    }
};

/* === мини-утилиты на чистом JS === */

/* аналог slideDown jQuery */
function slideDown(el, duration) {
    el.style.display = 'block';
    var height = el.offsetHeight;
    el.style.height = '0px';
    el.style.overflow = 'hidden';
    el.style.transition = 'height ' + duration + 'ms ease';
    /* reflow */
    el.offsetHeight;
    el.style.height = height + 'px';
    setTimeout(function() {
        el.style.height = '';
        el.style.overflow = '';
        el.style.transition = '';
    }, duration);
}

/* аналог animate({left: val}) */
function animate(el, props, duration, callback) {
    var start = performance.now();
    var from  = {};
    for (var p in props) from[p] = parseInt(getComputedStyle(el)[p], 10);
    function tick(ts) {
        var t = Math.min(1, (ts - start) / duration);
        for (var p in props) {
            el.style[p] = (from[p] + (props[p] - from[p]) * t) + 'px';
        }
        if (t < 1) requestAnimationFrame(tick);
        else if (callback) callback();
    }
    requestAnimationFrame(tick);
}
export { ModAlert };